import standardStore, { useStandardStore } from '@input-web/modules/standard/stores/standard.store';
import { ScoringStandard } from '@standard/models/scoring-standard.model';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import standardQuestionDetailRoute from '../../../question-detail/standard-question-detail.route';

// #region Types
type UseStandardLayoutMenuProps = {
  partIdParam?: string;
  standardList?: ScoringStandard[];
};
// #endregion

export default function useStandardLayoutMenu({
  partIdParam,
  standardList,
}: UseStandardLayoutMenuProps) {
  // #region Dependencies
  const navigate = useNavigate();
  const { shouldConfirmLeavingForm } = useStandardStore();
  // #endregion

  // #region Computed Values
  const items = useMemo(
    () =>
      standardList?.map((item) => ({
        active: item.partId === partIdParam,
        key: item.partId,
        label: item.partTitle,
        onClick: () => {
          const onNavigate = () => {
            navigate({
              params: { partId: item.partId },
              search: (current) => ({ ...current, questionId: undefined }),
              state: true,
              to: standardQuestionDetailRoute.fullPath,
            });
          };

          if (shouldConfirmLeavingForm) {
            standardStore.actions.openConfirmationDialog({ onConfirm: onNavigate });
            return;
          }

          onNavigate();
        },
      })) ?? [],
    [standardList, navigate, partIdParam, shouldConfirmLeavingForm],
  );
  // #endregion

  return { items };
}
